import ReactTableBase from "../../Table/ReactTableBase";
import React from "react";
import {Link} from "react-router-dom";
import styles from "../../Table/ReactTableBase.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEdit, faExternalLink} from "@fortawesome/free-solid-svg-icons";
import {ImageIllustration} from "../../Image/ImageIllustration";
import BtnSwitch from "../../Button/BtnSwitch";
import stylesSwitch from "../../Button/BtnSwitch.module.css";
import {getUtilisateurRoleLabel} from "../../../services/UserService";
import RenderCellActif from "../../Table/RenderCellActif";
import RenderCellSplit from "../../Table/RenderCellSplit";
import Routing from "../../../services/routing";


const JustificatifTypeTable = ({ justificatifType, putActifOpenModal = null, putObligatoireOpenModal = null }) => {
    const data = React.useMemo(() => justificatifType, [justificatifType]);

    const renderCellLabel = ({ row, value }) => {
        return <Link to={Routing.generate({
            route: Routing.routes.adminJustificatifsType,
            params: { typeId: row.original.justId }
        })}>{RenderCellSplit({ value: value })}</Link>;
    }

    const renderCellRoles = ({ value }) => {
        return value.map((role) => {
            return getUtilisateurRoleLabel(role);
        }).join(", ");
    }

    const renderCellActions = ({ row, value }) => {
        return (
            <div className={styles.actions}>
                <Link to={Routing.generate({
                    route: Routing.routes.adminJustificatifsType,
                    params: { typeId: row.original.justId }
                })}>
                    <FontAwesomeIcon icon={faExternalLink}/>
                    Détail
                </Link>
                <Link to={Routing.generate({
                    route: Routing.routes.adminJustificatifsType,
                    params: { typeId: row.original.justId },
                    queryParams: { mode: "creation" }
                })}>
                    <FontAwesomeIcon icon={faEdit}/>
                    Modifier
                </Link>
            </div>
        );
    }

    const renderCellObligatoire = ({ value, row }) => {
        if(putActifOpenModal === null) return value ? "Actif" : "Inactif";
        return <BtnSwitch active={value} onToggle={() => putObligatoireOpenModal(row.original)} activeLabel={"Exigé"} inactiveLabel={"Optionnel"} classNames={`${stylesSwitch.sliderCard} ${stylesSwitch.sliderCardDark}`}/>;
    }

    const columns = [
        /*{
            Header: 'Id',
            accessor: 'justId',
            Cell: renderCellId,
        },*/
        {
            Header: 'Label',
            accessor: 'justLabel',
            Cell: renderCellLabel,
        },
        {
            Header: 'Rôles',
            accessor: 'justRole',
            Cell: renderCellRoles,
        },
        {
            Header: 'Actif',
            accessor: 'justActif',
            isBoolean: true,
            Cell: (props) => <RenderCellActif {...props} putActifOpenModal={putActifOpenModal} />,
        },
        {
            Header: 'Exigé',
            accessor: 'justObligatoire',
            isBoolean: true,
            Cell: renderCellObligatoire
        },
        {
            Header: 'Actions',
            id: 'actions',
            Cell: renderCellActions,
        },
    ];

    return (
        <ReactTableBase dataSource={justificatifType} columnsData={columns} />
    );
}

export default JustificatifTypeTable;